<template>
    <div class="container remove-padding-margin">
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"
                  v-if="isClickedloader === true"></span>
        </div>
        <div class="header-top bg-white">
            <div class="nav-center pageDefault w-limit">
                <div class="row justify-content-center align-items-center set-row">
                    <div class="col-md-3 col-sm-3 col-3 remove-padding" @click="dashboard">
                        <img class="remove-padding-margin" @click="" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div class="col-md-6 col-sm-6 col-6 text-center remove-padding">
                        <div class="remove-margin">Akun Pemilik Usaha</div>
                    </div>
                    <div class="col-md-3 col-sm-3 col-3 remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="w-limit">
            <div class="upload-file text-alignC pad-top-50" id="section-1">
                <div v-if="logourl != ''" class="upload-file-wrapper mar-top-20 mar-bottom-20">
                    <label for="file">
                        <figure class="box">
                            <img class="imgFit logo" v-bind:src="logourl" alt="">
                        </figure>
                        <div class="pointer-upload">
                            <img src="../../assets/icons/camera1.svg" alt="">
                        </div>
                    </label>
                    <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUploadowner"
                           accept=".png, .jpg, .jpeg"/>
                </div>
                <div v-else class="upload-file-wrapper mar-top-20 mar-bottom-20">
                    <label for="file">
                        <img src="../../assets/gambar/Rectangle43.svg" alt=""
                             style="width: 98px;height: 98px;border-radius: 3px;" class="logo">
                        <div class="pointer-upload">
                            <img src="../../assets/icons/camera1.svg" alt="">
                        </div>
                    </label>
                    <input class="input-upload" type='file' id="file" ref="file" v-on:change="handleFileUploadowner"
                           accept="image/png,image/jpg,image/jpeg">
                </div>
            </div>

            <div class="mar-top-12" id="section-2">
                <div class="row remove-margin add-padding-default text-detailO" :data-toggle="validateAccess('account.update') ? 'modal' : ''"
                     data-target="#modalname">
                    <div class="flex-1">
                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Nama Pemilik</div>
                        <div class="font-16 color-0000 line-height-25 letter-space-002">{{owner.nama}}</div>
                    </div>
                    <div v-if="validateAccess('account.update')" class="hash">
                        <span><i class="far fa-edit color-206CF"></i></span>
                    </div>
                </div>

                <div class="row remove-margin add-padding-default text-detailO" :data-toggle="validateAccess('account.update') ? 'modal' : ''"
                     data-target="#modalkotaowner">
                    <div class="flex-1 ">
                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Kota Domisili</div>
                        <div class="font-16 color-0000 line-height-25 letter-space-002">{{domisili}}</div>
                    </div>
                    <div v-if="validateAccess('account.update')" class="hash">
                        <span><i class="far fa-edit color-206CF" :data-toggle="validateAccess('account.update') ? 'modal' : ''"
                                 data-target="#modalEname"></i></span>
                    </div>
                </div>

                <div class="row remove-margin add-padding-default text-detailO" :data-toggle="validateAccess('account.update') ? 'modal' : ''"
                     data-target="#modalusahapemilik">
                    <div class="flex-1 ">
                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Nama Perusahaan</div>
                        <div class="font-16 color-EB5757 line-height-25 letter-space-002" v-if="owner.nama_usaha===''">
                            Belum diatur
                        </div>
                        <div class="font-16 color-0000 line-height-25 letter-space-002" v-else>{{owner.nama_usaha}}
                        </div>
                    </div>
                    <div v-if="validateAccess('account.update')" class="hash">
                        <span><i class="far fa-edit color-206CF"></i></span>
                    </div>
                </div>
            </div>

            <div class="pembatas-new"></div>
	
	        <div class="mar-top-12" id="section-6" @click="upgradePowerMerchant()">
		        <div class="row remove-margin add-padding-default text-detailO"
		             v-if="owner.is_premium === 1">
			        <div class="flex-1">
				        <div class="font-16 color-0000 line-height-25 letter-space-002">Power Merchant</div>
				        <div class="font-14 color-6f7 line-height-20 letter-space-002">
					        <img src="../../assets/img/power-merchant.png" alt="" style="margin-top: -4px"/>
					        Anda telah terdaftar power merchant
				        </div>
			        </div>
			        <div class="hash">
				        <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
			        </div>
		        </div>
		        <div class="row remove-margin add-padding-default text-detailO"
		             v-else-if="owner.is_premium === 0">
			        <div class="flex-1">
				        <div class="font-16 color-0000 line-height-25 letter-space-002">Power Merchant</div>
				        <div class="font-14 color-6f7 line-height-20 letter-space-002">
					        Akun anda masih Regular Merchant. Klik disini untuk upgrade menjadi Power Merchant
				        </div>
			        </div>
			        <div class="hash">
				        <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
			        </div>
		        </div>
	        </div>

            <div class="pembatas-new"></div>

            <div class="mar-top-16" id="section-3">
                <div>
                    <div class="add-padding-default font-14 color-0000 line-height-20 letter-space-002">Pengaturan
                        Otentikasi
                    </div>
                    <div class="row remove-margin add-padding-default text-detailO" @click="gologinwa"
                        v-if="owner.is_premium === 0">
                        <div class="flex-1">
                            <div class="font-16 line-height-25 letter-space-002 color-0000">Login
                                Nomor WA
                            </div>
                            <div class="font-14 color-6f7 line-height-20 letter-space-002" v-if="owner.telp===''">
                                {{owner.telp}}
                            </div>
                            <div class="font-14 color-6f7 line-height-20 letter-space-002" v-else>{{owner.telp}}</div>
                        </div>
                        <div class="hash">
                            <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
                        </div>
                    </div>
	                <div class="row remove-margin add-padding-default text-detailO" @click="editakunPowerMerchant"
	                     v-else>
		                <div class="flex-1">
			                <div class="font-16 line-height-25 letter-space-002 color-0000">Login
				                Nomor WA
			                </div>
			                <div class="font-14 color-6f7 line-height-20 letter-space-002" v-if="owner.telp===''">
				                {{owner.telp}}
			                </div>
			                <div class="font-14 color-6f7 line-height-20 letter-space-002" v-else>{{owner.telp}}</div>
		                </div>
		                <div class="hash">
			                <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
		                </div>
	                </div>

                    <div class="row remove-margin add-padding-default pad-12-20"
                         v-if="owner.is_premium === 0">
                        <div class="flex-1" v-if="owner.email===''" @click="gosetemail">
                            <div class="font-16 line-height-25 letter-space-002 color-0000">Login Email</div>
                            <div class="font-14 color-EB5757 line-height-20 letter-space-002 ">Belum diatur</div>
                        </div>

                        <div class="flex-1" v-else @click="gologinemail">
                            <div class="font-16 line-height-25 letter-space-002 color-0000">Login Email</div>
                            <div class="font-14 color-6f7 line-height-20 letter-space-002">{{owner.email}}</div>
                        </div>

                        <div class="hash">
                            <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
                        </div>
                    </div>
	                <div class="row remove-margin add-padding-default pad-12-20" v-else>
		                <div class="flex-1" @click="editakunPowerMerchant">
			                <div class="font-16 line-height-25 letter-space-002 color-0000">Login Email</div>
			                <div class="font-14 color-6f7 line-height-20 letter-space-002">{{owner.email}}</div>
		                </div>
		
		                <div class="hash">
			                <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
		                </div>
	                </div>
                </div>
            </div>
            <div class="pembatas-new"></div>
            <div class="mar-top-20 m-d-20" id="section-42">
                <div class="row remove-margin add-padding-default mar-top-bot-15">
                    <div class="flex-1" @click="subscribeLetter(owner.telp)">
                        <div class="font-16 line-height-25 letter-space-002 color-0000">Broadcast Info Update Smartlink</div>
<!--                        <div class="font-14 color-6f7 line-height-20 letter-space-002">-->
<!--                            status:<b class="color-red"> Subscribe </b>-->
<!--                        </div>-->

                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Jika anda mengaktifkan, maka anda siap menerima pesan info dan pemberitahuan yang dibroadcast oleh smartlink via whatsapp ke nomor {{owner.telp}}</div>
                    </div>
                    <div class="hash">
                        <span><img class="" src="../../assets/icons/chevron-right1.svg" alt=""></span>
                    </div>

                </div>
            </div>

            <div class="pembatas-new"></div>
            <div class="mar-top-20 m-d-20" id="section-41">
                <div class="row remove-margin add-padding-default mar-top-bot-15">
                    <div class="flex-1" @click="debugApp">
                        <div class="font-16 line-height-25 letter-space-002 color-0000">Info Debug</div>
                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Lihat informasi data</div>
                    </div>
                </div>
            </div>
			
			<div class="pembatas-new"/>
			<div class="mar-top-20 m-d-20" id="section-41">
				<div class="row remove-margin add-padding-default mar-top-bot-15">
					<div class="flex-1" @click="$router.push('/session')">
						<div class="font-16 line-height-25 letter-space-002 color-0000">Sesi Smartowner Aktif</div>
						<div class="font-14 color-6f7 line-height-20 letter-space-002">Lihat informasi sesi</div>
					</div>
				</div>
			</div>

            <div class="pembatas-new"></div>
            <div class="mar-top-20 m-d-20" id="section-4" v-if="!isWebview()">
                <div class="row remove-margin add-padding-default mar-top-bot-15">
                    <div class="flex-2 powerBox">
                        <span><img class="" src="../../assets/icons/power.svg" alt=""></span>
                    </div>
                    <div class="flex-1" @click="logoutApp">
                        <div class="font-16 line-height-25 letter-space-002 color-0000">Logout</div>
                        <div class="font-14 color-6f7 line-height-20 letter-space-002">Keluar dari akun anda</div>
                    </div>
                </div>
            </div>
            <div class="pembatas-new" v-if="!isWebview()"></div>
        </main>
        <div class="modal fade" id="modalname" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Ubah Nama Pemilik </h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row remove-margin">
                            <label class="remove-margin mar-top-12 color-6f7 require">Nama Pemilik</label>
                            <input type="text" class="form-control inputs" placeholder="Budi Fasolasido"
                                   v-model="nama_owner" v-on:keyup="inputnama">
	                        <ErrorMessage class="error" label="Nama Pemilik" :validation="$v.nama_owner"></ErrorMessage>
                        </div>
                    </div>
                    <div class="modal-footer remove-mar-lr">
                        <div style="margin-right: 0px">
                            <button type="button" class="btn btn-primary btn-long"
                                    @click="editnamaowner" id="btneditnamaowner">Simpan Perubahan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalusahapemilik" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Ubah Nama Perusahaan </h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="row remove-margin">
                            <label class="remove-margin mar-top-12 color-6f7 require">Nama Perusahaan</label>
                            <input type="text" class="form-control inputs"
                                   placeholder="Contoh: CV. LAUNDRY JAYA" v-model="nama_usaha"
                                   v-on:keyup="inputpt">
	                        <ErrorMessage class="error" label="Nama Pemilik" :validation="$v.nama_usaha"></ErrorMessage>
                        </div>
                    </div>
                    <div class="modal-footer remove-mar-lr">
                        <div style="margin-right: 0px">
                            <button type="button" class="btn btn-primary btn-long"
                                    @click="editusaha" id="btneditpt">Simpan Perubahan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalkotaowner" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Ubah Domisili</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body set-modal-body">
                        <label class="remove-margin font-14 color-6f7 add-padding-default right-25">Kota
                            Domisili</label>
                        <Select2 class="test-select fl-is-required inputs mod add-padding-default" id="select2"
                                 v-model="owner.kota" :options="optionkota"
                                 :settings="{ placeholder: 'Pilih Kota' }"/>
	                    <ErrorMessage class="error" label="Nama Pemilik" :validation="$v.owner.kota"></ErrorMessage>
                    </div>
                    <div class="modal-footer">
                        <div style="margin-right: 0px">
                            <button type="button" class="btn btn-primary btn-long"
                                    @click="updatekota" id="btneditkota">Simpan Perubahan
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Select2 from 'v-select2-component';
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "DetailAkun",
        components: {Select2,ErrorMessage},
        data() {
            return {
                owner: {},
                optionkota: [],
                nama_owner: '',
                nama_usaha: '',
                domisili: '',
                logourl: '',
                sourcelogo: '',
                logourltemp: '',
                isClickedloader: true,
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    nama_owner: {
		    	required,
			    minLength: minLength(2),
		    },
		    nama_usaha: {
		    	required,
			    minLength: minLength(2),
		    },
		    owner: {
		    	kota: {
		    		required,
			    }
		    }
	    },
        mounted() {
            $('#closeS').hide()
            $('#close').hide()
            this.getdetailowner()
            this.getkota()
            this.cekvalidatename()
            this.cekvalidateusaha()
            this.smartTrackingView('profile')
        },
        methods: {
            upgradePowerMerchant() {
                this.$router.push({name: "ibos", query: {part: 'akun-premium/status', label: 'Power Merchant'}});
            },
	        editakunPowerMerchant() {
		        this.$router.push({name: "ibos", query: {part: 'profil', label: 'Akun Pemilik Usaha'}});
	        },
            debugApp(){
                this.$router.push('/debugapp')

            },
            subscribeLetter(telpon){
                this.$router.push('/subscribe/'+telpon)
            },
            dashboard() {
                this.$router.push('/dashboard')
            },

            gologinwa() {
                this.$router.push('/loginownerwa')
            },

            gologinemail() {
                this.$router.push('/loginowneremail')
            },

            gosetemail() {
                this.$router.push('/setemailowner')
            },

            outlet() {
                this.$router.push('/homeoutlet')
            },

            karyawan() {
                this.$router.push('/karyawan')
            },
            logoutOwner() {
                $('#loadingPage').addClass('overlayLoading');
                var myItem = localStorage.getItem('incontext-device');
                localStorage.clear();
                localStorage.setItem('incontext-device',myItem);
                this.$router.push('/login');
                $('#loadingPage').removeClass('overlayLoading');
            },

            myChangeEvent(val) {
                this.myValue = val
            },
            mySelectEvent(e) {
                this.owner.kota = e.text;
                this.owner.kota_id = e.id;
            },

            cekvalidatename() {
            	return
                var staffname = this.nama_owner;
                var lenPass = staffname.length;
                if (lenPass > 2) {
                    $('#btneditnamaowner').prop('disabled', false);
                } else {
                    $('#btneditnamaowner').prop('disabled', true);
                }
            },

            cekvalidateusaha() {
            	return
                var staffname = this.nama_usaha;
                var lenPass = staffname.length;
                if (lenPass >= 2) {
                    $('#btneditpt').prop('disabled', false);
                } else {
                    $('#btneditpt').prop('disabled', true);
                }
            },

            inputnama(event) {
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,' -]+/, '');
                this.nama_owner = handle;
                this.cekvalidatename()
            },

            inputpt(event) {
                var name = event.target.value;
                var handle = name.replace(/[^0-9A-Za-z_.,' -]+/, '');
                this.nama_usaha = handle;
                this.cekvalidateusaha()
            },

            handleFileUploadowner() {
                this.logourl = this.$refs.file.files[0];
                var FileSize = this.$refs.file.files[0].size / 1024 / 1024;
                var validphoto = [".jpg", ".jpeg", ".bmp", ".gif", ".png"];
                if (FileSize > 2) {
                	this.$toast.error('File Gambar tidak boleh lebih dari 2 MB, file anda ' + FileSize.toFixed(2) + ' MB')
                    $('#file').val("");
                    if (this.logourl == "") {
                        $('.logo').attr('src', '/img/Rectangle43.b88d5998.svg');
                    } else {
                        $('.logo').attr('src', this.logourl);
                    }
                } else {
                    var blnValid = false;
                    for (var j = 0; j < validphoto.length; j++) {
                        var sCurExtension = validphoto[j];
                        if (this.logourl.name.substr(this.logourl.name.length - sCurExtension.length, sCurExtension.length).toLowerCase() == sCurExtension.toLowerCase()) {
                            blnValid = true;
                        }
                    }
                    if (!blnValid) {
                    	this.$toast.error('File photo harus menggunakan format jpg, jpeg, dan png')
                    } else {
                        $('.logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
                        this.updatepicture()
                    }
                }
            },

            async updatepicture() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const updatedata = new FormData()
                    updatedata.append('logo_url', this.logourl)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_foto_profil_pemilik', updatedata, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').show();
                        this.isClickedloader = false;
                        this.$toast.success(response.data.msg)
                        this.getdetailowner()
                    } else {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').show();
                        this.isClickedloader = false;
                        this.$toast.error(response.data.msg)
                        if (this.logourltemp == "") {
                            $('.logo').attr('src', '/img/Rectangle43.b88d5998.svg');
                        } else {
                            $('.logo').attr('src', this.logourltemp);
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false;
	                if (this.logourl == "") {
		                $('.logo').attr('src', '/img/Rectangle43.b88d5998.svg');
	                } else {
		                $('.logo').attr('src', URL.createObjectURL(this.$refs.file.files[0]));
	                }
                }
            },

            async getdetailowner() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    var telp = localStorage.getItem("telp");
                    const res = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner', this.requestHeaders);
                    this.owner = res.data.data
                    if (res.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        this.isClickedloader = false;
                        // $('#loadingPage').hide();
                        var dataowner = res.data.data
                        this.nama_owner = dataowner.nama;
                        this.nama_usaha = dataowner.nama_usaha;
                        this.domisili = dataowner.kota_name.nama;
                        if (dataowner.idfotoprofil !== '' && dataowner.idfotoprofil !== null) {
                            if (dataowner.logo_url !== '' && dataowner.logo_url !== null) {
                                this.logourl = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url
                                this.logourltemp = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url

                            } else {
                                this.logourl = 'https://res.cloudinary.com/sinadme/c_scale,h_200/' + dataowner.idfotoprofil
                                this.logourltemp = 'https://res.cloudinary.com/sinadme/c_scale,h_200/' + dataowner.idfotoprofil
                            }
                        } else {
                            if (dataowner.logo_url === '' || dataowner.logo_url === null) {
                                this.logourl = ''
                                this.logourltemp = ''
                            } else {
                                this.logourl = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url
                                this.logourltemp = 'https://storage.googleapis.com/ember-e-dalbo/' + dataowner.logo_url
                            }
                        }
                        this.cekvalidatename()
                        this.cekvalidateusaha()
                    } else {

                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },

            async editnamaowner() {
            	if (this.$v.nama_owner.$invalid) {
		            this.$v.nama_owner.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const editname = new FormData();
                    editname.append('nama_pemilik', this.nama_owner)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_nama_owner', editname, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    this.$toast.success(response.data.msg)
                        this.getdetailowner()
	                    $("#modalname").modal("hide")
                    } else {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },

            async editusaha() {
            	if (this.$v.nama_usaha.$invalid) {
		            this.$v.nama_usaha.touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').show();
                this.isClickedloader = true
                try {
                    const editusaha = new FormData();
                    editusaha.append('nama_perusahaan', this.nama_usaha)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_nama_perusahaan', editusaha, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    this.$toast.success(response.data.msg)
                        this.getdetailowner()
	                    $("#modalusahapemilik").modal("hide")
                    } else {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
	                $('#textBtnpersonal').show()
	                $('#btnpersonal').prop('disabled', false);
                }
            },


            async updatekota() {
            	if (this.$v.owner.kota.$invalid) {
		            this.$v.modalkotaowner.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').hide();
                this.isClickedloader = true;
                try {
                    var idowner = localStorage.getItem('idowner')
                    const updatedata = new FormData()
                    updatedata.append('kota_domisili', this.owner.kota)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/ubah_kota_pemilik', updatedata, this.requestHeaders);
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
	                    this.$toast.success(response.data.msg)
                        this.getdetailowner()
	                    $("#modalkotaowner").modal("hide")
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                this.isClickedloader = false
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            async logoutApp() {
                try {
                    const forms = new FormData;
	                forms.append("idowner", localStorage.getItem("idowner"))
	                forms.append("token", localStorage.getItem("token"))
                    const response = await this.$axios.post(this.$baseurl + '/masterData/dashboard/logout_owner_token', forms);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            var myItem = localStorage.getItem('incontext-device');
                            localStorage.clear();
                            localStorage.setItem('incontext-device',myItem);

	                        if (this.getUserAgent() !== "ios") {
		                        if (localStorage.getItem("remember-token-firebase") !== null || localStorage.getItem("remember-token-firebase") === "undefined") {
			                        try {
				                        const messaging = firebaseToken.messaging();
				                        await messaging.deleteToken()
			                        } catch (e) {
				                        // ignore
			                        }
		                        }
	                        }

                            this.$router.push('login')
                        } else {
                        	this.$toast.error(response.data.msg)
                        }
                    } else {
                    	this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                	this.$catch_error_response(e)
                }
            },
            async getkota() {
                $('#loadingPage').addClass('overlayLoading');
                // $('#loadingPage').hide();
                this.isClickedloader = true
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/kota_meta')
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        // $('#loadingPage').hide();
                        this.isClickedloader = false
                        var rawkota = response.data.data;
                        this.optionkota.push({id: "", text: "Pilih Kota"})
                        for (var i = 0; i < rawkota.length; i++) {
                            this.optionkota.push({id: rawkota[i].id, text: rawkota[i].nama})
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                this.isClickedloader = false
                }
            },


        }
    }
</script>

<style scoped>
    .powerBox {
        padding: 10px;
    }

    #navbar-bottom {
        max-width: 540px;
        margin: auto;
    }

    #navbar-bottom .navbar-container {
        display: flex;
        flex-wrap: wrap;
    }

    #navbar-bottom div.navbar-item {
        text-align: center;
        font-size: 11px;
        padding: 12px 0px;
        width: calc(100% / 5);
    }

    #navbar-bottom .navbar-item .menu-label {
        padding: 0 2px;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-top: 4px;
        color: #6F7287;
        /* word-break: break-word; */
    }

    #navbar-bottom .navbar-item.active .menu-icon svg path {
        fill: #206CFF;
    }

    #navbar-bottom .navbar-item.active .menu-label {
        color: #206CFF;
        font-weight: bold;
    }

    .pointer-upload {
        display: flex;
        width: 33px;
        height: 33px;
        border-radius: 50%;
        background: #206CFF;
        cursor: pointer;
        box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
        /*animation: pulse 2s infinite;*/
        align-content: center;
        align-items: center;
        justify-content: center;
        position: absolute;
        /* bottom: 70px; */
        right: -15px;
        bottom: -15px;
    }

    .upload-file {
        border-bottom: 1px solid #EDEDED;
    }

    .upload-file-wrapper {
        width: 100px;
        height: 100px;
        margin: 20px auto;
        border: 1px solid rgba(0, 0, 0, 0.15);
        position: relative;
    }

    .input-upload {
        display: none;
    }

    .box {
        width: 95.53px;
        height: 95.53px;
    }

    .imgFit {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 3px;
        margin-top: 2px;
    }

    .nomore {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .text-desc {
        line-height: 140%;
        letter-spacing: -0.02em;
        color: #333333;
    }

    .view-original .modal {
         left: auto !important;
        overflow: hidden !important;
    }
    .view-iframe .modal {
        /* left: auto !important; */
        overflow: hidden !important;
    }
</style>